import React, { useEffect, useState } from "react";
import { useIdleTimer } from 'react-idle-timer';
import { setLoginDetails, setPermissionDetails } from "../../action/set-action-details";
import { connect } from "react-redux";
import GeneralSubMenu from "./general-sub-menu";
import GeneralMainMenu from "./general-main-menu";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { GeneralMobileHeader } from "./general-mobile-header";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/img/logoo-.png";
import { Bars3Icon, ArrowRightOnRectangleIcon, SunIcon, MoonIcon } from "@heroicons/react/24/outline";

function GeneralHeader(props) {
    const [menuList, setMenuList] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem("theme");
        if (savedTheme) {
            return savedTheme;
        }
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    });
    
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState);
    };

    const [width, setWidth] = useState(window.innerWidth);
    
    useEffect(() => {
        // Initialize theme on mount
        const root = document.documentElement;
        if (theme === "dark") {
            root.classList.add("dark");
        } else {
            root.classList.remove("dark");
        }
        localStorage.setItem("theme", theme);
    }, []);

    useEffect(() => {
        const handleThemeChange = () => {
            const currentTheme = document.documentElement.classList.contains("dark") ? "dark" : "light";
            setTheme(currentTheme);
        };
        window.addEventListener("themechange", handleThemeChange);
        const observer = new MutationObserver(handleThemeChange);
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
        return () => {
            window.removeEventListener("themechange", handleThemeChange);
            observer.disconnect();
        };
    }, []);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    };

    const SESSION_IDLE_MINUTES = 120;
    const handleOnIdle = (event) => {
        console.log('last active', getLastActiveTime())
        signOut();
    }

    const { getLastActiveTime } = useIdleTimer({
        timeout: 1000 * 60 * SESSION_IDLE_MINUTES,
        onIdle: handleOnIdle,
        debounce: 500,
    })
    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;

    const signOut = () => {
        props.setOnLoginDetails([]);
        props.setOnPermissionDetails([]);
    };

    useEffect(() => {
        if (props.permissionData.length > 0) {
            const menu_key = "menu_name";
            const menu_list = [
                ...new Map(props.permissionData.map(menu =>
                    [menu[menu_key], menu])).values()
            ];
            setMenuList(menu_list)
        }
    }, [])

    const location = useLocation();

    return (
        <div id="kt_header" className="print:hidden sticky top-0 z-50 bg-white dark:bg-slate-800 shadow-sm border-b border-slate-200 dark:border-slate-700 transition-colors duration-200">
            {/* Header top */}
            <div className="bg-gradient-to-r from-indigo-700 to-indigo-800 dark:from-indigo-800 dark:to-indigo-900 shadow-md transition-colors duration-200">
                <div className="mx-auto max-w-full px-3 sm:px-4 lg:px-8">
                    <div className="flex items-center justify-between h-14 sm:h-16 lg:h-20">
                        {/* Brand and Logo */}
                        <div className="flex items-center flex-1 min-w-0">
                            {/* Mobile menu toggle */}
                            <button 
                                onClick={toggleDrawer} 
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        toggleDrawer();
                                    }
                                }}
                                className="lg:hidden p-2 rounded-lg text-white hover:bg-white/10 transition-colors duration-200 mr-2 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-700"
                                id="kt_header_navs_toggle"
                                aria-label="Toggle menu"
                                aria-expanded={isOpen}
                                aria-controls="mobile-menu"
                            >
                                <Bars3Icon className="w-6 h-6" aria-hidden="true" />
                            </button>
                            
                            {/* Logo */}
                            <Link to={"/"} className="flex-shrink-0 mr-3 sm:mr-5">
                                <img alt="Logo" src={Logo} className="h-5 sm:h-6 lg:h-10" />
                            </Link>
                            
                            {/* Main Menu Tabs */}
                            <div className="hidden lg:flex items-center flex-1">
                                <GeneralMainMenu menuList={menuList} />
                            </div>
                        </div>

                        {/* Topbar - User and Actions */}
                        <div className="flex items-center space-x-2">
                            {/* Theme Toggle */}
                            <button
                                onClick={() => {
                                    const newTheme = theme === "light" ? "dark" : "light";
                                    document.documentElement.classList.toggle("dark");
                                    localStorage.setItem("theme", newTheme);
                                    setTheme(newTheme);
                                    window.dispatchEvent(new Event("themechange"));
                                }}
                                className="p-2 rounded-lg text-white hover:bg-white/10 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-700 touch-manipulation"
                                aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
                                title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
                            >
                                {theme === "light" ? (
                                    <MoonIcon className="h-5 w-5" aria-hidden="true" />
                                ) : (
                                    <SunIcon className="h-5 w-5" aria-hidden="true" />
                                )}
                            </button>
                            {/* Sign Out Button */}
                            <button
                                onClick={signOut}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        signOut();
                                    }
                                }}
                                className="p-2 rounded-lg text-white hover:bg-white/10 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-700"
                                title="Sign out"
                                aria-label="Sign out"
                            >
                                <ArrowRightOnRectangleIcon className="w-5 h-5" aria-hidden="true" />
                            </button>

                            {/* User Info */}
                            <div className="hidden md:flex items-center" id="kt_header_user_menu_toggle">
                                <Link 
                                    to={"staff/profile"}
                                    className="flex items-center px-3 py-2 rounded-lg hover:bg-white/10 transition-colors duration-200"
                                >
                                    <div className="flex flex-col items-end mr-2">
                                        <span className="text-white/75 text-xs font-medium">Hello,</span>
                                        <span className="text-white text-sm font-bold">{props.loginData[0]?.full_name || 'User'}</span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Header navs - Sub Menu */}
            {!isMobile ? (
                <div className="bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 shadow-sm transition-colors duration-200">
                    <GeneralSubMenu />
                </div>
            ) : (
                <Drawer open={isOpen} onClose={toggleDrawer} direction="left">
                    <GeneralMobileHeader permissionData={props.permissionData} onClose={setIsOpen} />
                </Drawer>
            )}
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
        permissionData: state.PermissionDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnPermissionDetails: (p) => {
            dispatch(setPermissionDetails(p));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralHeader);
